/**
 * Trainer sprite presets and B2W2 battle backgrounds.
 */

export type TrainerPreset = {
  id: string;
  name: string;
  frontSprite: string;
  backSprite: string;
  vsSprite: string;
};

export const TRAINER_PRESETS: TrainerPreset[] = [
  {
    id: "bianca",
    name: "Bianca",
    frontSprite: "Bianca_B2W2.png",
    backSprite: "Bianca_B2W2_back.png",
    vsSprite: "Bianca_B2W2_vs.png",
  },
  {
    id: "cheren",
    name: "Cheren",
    frontSprite: "Cheren_B2W2.png",
    backSprite: "Cheren_B2W2_back.png",
    vsSprite: "Cheren_B2W2_vs.png",
  },
  {
    id: "cheren2",
    name: "Cheren (Variant)",
    frontSprite: "Cheren2_B2W2.png",
    backSprite: "Cheren2_B2W2_back.png",
    vsSprite: "Cheren2_B2W2_vs.png",
  },
  {
    id: "chili",
    name: "Chili",
    frontSprite: "Chili_B2W2.png",
    backSprite: "Chili_B2W2_back.png",
    vsSprite: "Chili_B2W2_vs.png",
  },
  {
    id: "cilan",
    name: "Cilan",
    frontSprite: "Cilan_B2W2.png",
    backSprite: "Cilan_B2W2_back.png",
    vsSprite: "Cilan_B2W2_vs.png",
  },
  {
    id: "cress",
    name: "Cress",
    frontSprite: "Cress_B2W2.png",
    backSprite: "Cress_B2W2_back.png",
    vsSprite: "Cress_B2W2_vs.png",
  },
  {
    id: "hilbert",
    name: "Hilbert (Male)",
    frontSprite: "Hilbert_B2W2.png",
    backSprite: "Hilbert_B2W2_back.png",
    vsSprite: "Hilbert_B2W2_vs.png",
  },
  {
    id: "hilda",
    name: "Hilda (Female)",
    frontSprite: "Hilda_B2W2.png",
    backSprite: "Hilda_B2W2_back.png",
    vsSprite: "Hilda_B2W2_vs.png",
  },
  {
    id: "hugh",
    name: "Hugh",
    frontSprite: "Hugh_B2W2.png",
    backSprite: "Hugh_B2W2_back.png",
    vsSprite: "Hugh_B2W2_vs.png",
  },
  {
    id: "nate",
    name: "Nate",
    frontSprite: "Nate_B2W2.png",
    backSprite: "Nate_B2W2_back.png",
    vsSprite: "Nate_B2W2_vs.png",
  },
  {
    id: "rosa",
    name: "Rosa",
    frontSprite: "Rosa_B2W2.png",
    backSprite: "Rosa_B2W2_back.png",
    vsSprite: "Rosa_B2W2_vs.png",
  },
];

export const DEFAULT_TRAINER_ID = "hilbert";

export function getTrainerPreset(id: string): TrainerPreset | undefined {
  return TRAINER_PRESETS.find((t) => t.id === id);
}

export type BattleBackground = {
  id: string;
  name: string;
  filename: string;
};

export const BATTLE_BACKGROUNDS: BattleBackground[] = [
  { id: "grass", name: "Grass Field", filename: "grass.png" },
  { id: "forest", name: "Forest", filename: "forest.png" },
  { id: "cave", name: "Cave", filename: "cave.png" },
  { id: "mountain", name: "Mountain", filename: "mountain.png" },
  { id: "water", name: "Water", filename: "water.png" },
  { id: "beach", name: "Beach", filename: "beach.png" },
  { id: "desert", name: "Desert", filename: "desert.png" },
  { id: "city", name: "City", filename: "city.png" },
  { id: "building", name: "Building Interior", filename: "building.png" },
  { id: "ice", name: "Ice Cave", filename: "ice.png" },
  { id: "volcano", name: "Volcano", filename: "volcano.png" },
  { id: "power-plant", name: "Power Plant", filename: "power-plant.png" },
];

export function randomBattleBackground(): BattleBackground {
  return BATTLE_BACKGROUNDS[
    Math.floor(Math.random() * BATTLE_BACKGROUNDS.length)
  ];
}

export function getBattleBackground(id: string): BattleBackground | undefined {
  return BATTLE_BACKGROUNDS.find((b) => b.id === id);
}

export function getBattleBackgroundImageUrl(id: string): string {
  const bg = getBattleBackground(id);
  if (!bg) return "";
  return `/assets/sprites/backgrounds/${bg.filename}`;
}

export function defaultBattleBackgroundColor(): string {
  return "#1a1a2e";
}
